export default __webpack_public_path__ + "static/media/50_mobile.4435527e.jpg";